import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoList, IoCompass, IoChatbubble, IoPerson } from 'react-icons/io5';

const FooterTabBarLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const TABS = [
    { id: 'list', icon: IoList, label: '목록', path: '/app/meetings' },
    { id: 'explore', icon: IoCompass, label: '탐색', path: '/app/explore' },
    { id: 'chat', icon: IoChatbubble, label: '채팅', path: '/app/chat' },
    { id: 'profile', icon: IoPerson, label: '마이', path: '/app/mypage' },
  ];

  const handleTabClick = (path) => {
    navigate(path);
  };

  return (
    <div className="flex flex-col h-screen bg-white">
      {/* 메인 콘텐츠 영역 */}
      <div className="flex-1 overflow-auto">
        {children}
      </div>

      {/* 하단 탭 바 */}
      <div className="bg-white border-t border-gray-200">
        <div className="flex justify-around items-center py-2">
          {TABS.map((tab) => {
            const isActive = location.pathname === tab.path;
            const Icon = tab.icon;

            return (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.path)}
                className={`flex flex-col items-center py-2 px-4 rounded-lg transition-colors ${
                  isActive 
                    ? 'text-amber-500' 
                    : 'text-gray-600'
                }`}
              >
                <Icon size={24} className="mb-1" />
                <span className="text-xs font-medium">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FooterTabBarLayout;
